export default "__VITE_ASSET__C4fH5maF__"